<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12" class="pa-3">
               <locality-crud />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import LocalityCrud from "./LocalityCrud";
    export default {
        name: "Locality",
        components: {LocalityCrud}
    }
</script>

<style scoped>

</style>

